import script from "./OrderPageTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderPageTab.vue?vue&type=script&setup=true&lang=ts"

import "./OrderPageTab.vue?vue&type=style&index=0&id=7a14a7fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a14a7fe"]])

export default __exports__